import {
  createContext,
  Dispatch,
  ReactNode,
  useContext,
  useMemo,
  useState,
} from 'react'

export type ContactContextType = {
  isAccountsFiltersVisible: boolean
  isPaymentsFiltersVisible: boolean
  isPaymentsFilterButtonVisible: boolean
  setIsAccountsFiltersVisible: Dispatch<React.SetStateAction<boolean>>
  setIsPaymentsFiltersVisible: Dispatch<React.SetStateAction<boolean>>
  setIsPaymentsFilterButtonVisible: Dispatch<React.SetStateAction<boolean>>
}

export const ContactContext = createContext<ContactContextType | undefined>(
  undefined
)

ContactContext.displayName = 'Contact Context'

interface ContactProviderProps {
  children: ReactNode | ReactNode[]
}

export const ContactProvider = ({ children }: ContactProviderProps) => {
  const [isAccountsFiltersVisible, setIsAccountsFiltersVisible] =
    useState(false)

  const [isPaymentsFiltersVisible, setIsPaymentsFiltersVisible] =
    useState(false)

  const [isPaymentsFilterButtonVisible, setIsPaymentsFilterButtonVisible] =
    useState(false)

  const value = useMemo(
    () =>
      ({
        isPaymentsFiltersVisible,
        isAccountsFiltersVisible,
        isPaymentsFilterButtonVisible,
        setIsAccountsFiltersVisible,
        setIsPaymentsFiltersVisible,
        setIsPaymentsFilterButtonVisible,
      } satisfies ContactContextType),
    [
      isPaymentsFiltersVisible,
      isAccountsFiltersVisible,
      isPaymentsFilterButtonVisible,
      setIsAccountsFiltersVisible,
      setIsPaymentsFiltersVisible,
      setIsPaymentsFilterButtonVisible,
    ]
  )

  return (
    <ContactContext.Provider value={value}>{children}</ContactContext.Provider>
  )
}

export const useContactContext = () => {
  const context = useContext(ContactContext)

  if (!context) {
    throw new Error('useContactContext must be used within ContactContext')
  }

  return context
}
